import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {BranchSettlementMethodContainerModel} from '../../../../../../models/aggregates/branch';
import {Core2Config} from '../../shared/core2Config';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { ApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { BranchSettlementMethodCriteriaDTO } from '../../../data-transfer-objects/branch-settlement-method-dto.model';


@Injectable({
  providedIn: 'root'
})
export class BranchSettlementMethodService extends BaseApiTemplateService<BranchSettlementMethodContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branch-settlement-methods';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branch-settlement-methods';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'branch-settlement-methods';
    this.httpClient = http;
  }

  postMultiBranch(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + "/backoffice-ep/add-multi-branch";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  getBranchSettlementMethodByCriteriaPost(dtoObject: BranchSettlementMethodCriteriaDTO, visa: ApiVisa): Observable<PagingResponseModel<BranchSettlementMethodContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<PagingResponseModel<BranchSettlementMethodContainerModel>>(
      this.apiUrl + '/query',
      dtoObject,
      this.getHttpHeader(visa)
    )
  }

  retrieveSettlementMethodBranchCodes(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + "/backoffice-ep/retrieve-branch";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  addMultiple(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + "/backoffice-ep/add-multi";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
